import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon, MoonIcon } from "@heroicons/react/24/outline";

const navigation = [
  { name: "Mi portafolios", href: "https://japurecanonico.gitlab.io" },
  { name: "Mas proyectos", href: "https://gitlab.com/japurecanonico" },
  { name: "Repositorio", href: "https://gitlab.com/japurecanonico/lista-tareas-react" },
];

function TodoHeader(props) {
  return (
    <Disclosure as="nav" className="bg-white dark:bg-gray-700 text-black hover:text-gray-800 dark:text-gray-400 dark:hover:text-white fixed w-full z-10">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-black dark:focus:ring-white">
                  <span className="sr-only">Menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <h2 className="text-center pr-12 md:pr-0 text-xl text-black dark:text-white">
                  <span className="text-violet-400">&lt;</span>
                  japurecanonico
                  <span className="text-violet-400">/&gt;</span>
                </h2>
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="text-black hover:text-gray-800 dark:text-gray-400 dark:hover:text-white rounded-md px-3 py-2 text-sm font-medium"
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <button
                  type="button"
                  className="rounded-full p-1 text-black hover:text-gray-800 dark:text-gray-400 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                >
                  <span className="sr-only">Modo oscuro</span>
                  <MoonIcon className="h-6 w-6" aria-hidden="true" onClick={props.onDarkMode}/>
                </button>

                <div className="relative ml-3">
                  <div>
                    <a
                      className="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                      href="https://japurecanonico.gitlab.io"
                      target="_blank"
                    >
                      <span className="sr-only">Mi portafolios</span>
                      <img
                        className="h-10 w-10 rounded-full"
                        src="/profile.jpg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  target="_blank"
                  href={item.href}
                  className="text-black hover:text-gray-800 dark:text-gray-400 dark:hover:text-white block rounded-md px-3 py-2 text-base font-medium"
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export { TodoHeader };
